import Button from "@material-ui/core/Button";
import { ResetIcon } from "../../icons/ResetIcon";
import styled from "styled-components";
import { useAppState } from "../../shared/ContextProvider";

const StyledButton = styled(Button)`
  && {
    font-size: 13px;
    text-transform: lowercase;
    color: #2196f3;
  }
`;

export default function ResetBtn() {
  const { state, dispatch } = useAppState();

  const handleReset = () => {
    dispatch({ type: "RESET" });
    console.log("RESET:", state.reset);
  };

  return (
    <div>
      {state.reset && (
        <StyledButton onClick={handleReset} startIcon={<ResetIcon />}>
          필터링 리셋
        </StyledButton>
      )}
    </div>
  );
}
